import { EdgeProps } from "reactflow";
import EdgeBaseWrapper from "./EdgeBaseWrapper";
import { memo } from "react";

const SelectableDefaultEdge = (props: EdgeProps) => {
  const normalStrokeWidth = Number(props.style?.strokeWidth || 1);
  const fixedMarkerId = `fixed-marker-${props.id}`;
  const fixedMarkerSize = 25 * normalStrokeWidth;

  const customStyle = {
    ...props.style,
    stroke: props.selected ? "#3650DE" : props.style?.stroke || "#6e75ff",
    strokeWidth: props.selected ? 3 : normalStrokeWidth,
  };

  return (
    <EdgeBaseWrapper
      {...props}
      style={customStyle}
      markerEnd={
        props.selected && props.markerEnd
          ? `url(#${fixedMarkerId})`
          : props.markerEnd
      }
    >
      {props.selected && props.markerEnd && (
        <defs>
          <marker
            id={fixedMarkerId}
            markerWidth={fixedMarkerSize}
            markerHeight={fixedMarkerSize}
            viewBox="-10 -10 20 20"
            markerUnits="userSpaceOnUse"
            orient="auto-start-reverse"
          >
            <polyline stroke="red" fill="red" points="-5,-4 0,0 -5,4 -5,-4" />
          </marker>
        </defs>
      )}
    </EdgeBaseWrapper>
  );
};

export default memo(SelectableDefaultEdge);
